import React, { CSSProperties } from 'react';
import { FiltersMap } from '@wix/bex-core';
import { CollectionSearch, CollectionSearchProps } from './CollectionSearch';
import { observer } from 'mobx-react-lite';
import { useElementSize } from 'usehooks-ts';

export interface ExpandableSearchProps<T, F extends FiltersMap>
  extends CollectionSearchProps<T, F> {
  visibility?: CSSProperties['visibility'];
}

function _ExpandableSearch<T, F extends FiltersMap = FiltersMap>({
  visibility,
  ...rest
}: CollectionSearchProps<T, F>) {
  const [containerRef, { width }] = useElementSize();

  return (
    <div
      style={{
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-end',
      }}
      ref={containerRef}
    >
      <div style={{ marginLeft: 'auto' }}>
        <CollectionSearch {...rest} expandWidth={width} />
      </div>
    </div>
  );
}

export const ExpandableSearch = observer(_ExpandableSearch);
